import React, { Component } from 'react';
import BasemapGallery from 'esri/dijit/BasemapGallery';
import Measurement from 'esri/dijit/Measurement';
import BasemapLayer from 'esri/dijit/BasemapLayer';
import Basemap from 'esri/dijit/Basemap';
import Clipboard from 'clipboard';
import { mapActions } from 'actions/MapActions';
import { mapStore } from 'stores/MapStore';
import { defaultStrings } from 'js/config/config';
import {
  USA_TOPO_BASEMAP_URL,
  USA_TOPO_BASEMAP_THUMBNAIL_URL,
  USA_TOPO_BASEMAP_TITLE,
  ESRI_BASEMAPS_TITLES,
} from 'js/config/basemaps.config';

export class Map extends Component {
  constructor(props) {
    super(props);
    this.state = mapStore.getState();
    mapStore.listen(this.onChange.bind(this));
    this.state.showLink = true;
    this.state.measurementInstructions = '';
    this.measurementTool = {};
  }

  onChange() {
    this.setState(mapStore.getState());
  }

  componentDidUpdate() {
    if (!this.state.showMeasureTool && typeof this.measurementTool.setTool !== 'undefined') {
      this.measurementTool.setTool('area', false);
      this.measurementTool.setTool('distance', false);
      this.measurementTool.setTool('location', false);
      if (this.measurementTool.result !== null) {
        this.measurementTool.clearResult();
      }
    }
  }

  componentDidMount() {
    // if hash set new state immediately
    if (Object.keys(this.props.hash).length !== 0 && this.props.hash.constructor === Object) {
      mapActions.createMap(this.props.hash.z, this.props.hash.lat, this.props.hash.lon, this.props.hash.v);
      if (this.props.hash.v !== '') {
        mapActions.toggleLegend();
      }
    } else {
      mapActions.createMap();
    }

    mapActions.mapContainerLoaded();
    new Clipboard('.btn');

    let basemapGallery = (window.bmg = new BasemapGallery(
      {
        title: 'Basemap Gallery',
        map: mapStore.getState().map,
      },
      'basemapGallery'
    ));

    basemapGallery.on('load', () => {
      const basemapTitles = ESRI_BASEMAPS_TITLES;

      const filteredEsriBasemaps = basemapGallery.basemaps.filter((basemap) => {
        return basemapTitles.includes(basemap.title);
      });

      basemapGallery.basemaps = filteredEsriBasemaps;

      const basemapLayer = new BasemapLayer({
        url: USA_TOPO_BASEMAP_URL,
      });

      const usaTopoBasemap = new Basemap({
        layers: [basemapLayer],
        title: USA_TOPO_BASEMAP_TITLE,
        thumbnailUrl: USA_TOPO_BASEMAP_THUMBNAIL_URL,
      });

      basemapGallery.basemaps.push(usaTopoBasemap);
      basemapGallery.basemaps.sort((a, b) => (a.title > b.title ? 1 : -1));
      basemapGallery.startup();

      mapActions.saveBasemapGallery(basemapGallery);
    });

    let measurement = new Measurement(
      {
        map: mapStore.getState().map,
      },
      'measurementDiv'
    );

    measurement.on('tool-change', (args) => {
      switch (args.toolName) {
        case 'area':
          this.setState({
            measurementInstructions: defaultStrings.measureAreaInstruction,
          });
          break;
        case 'distance':
          this.setState({
            measurementInstructions: defaultStrings.measureDistanceInstruction,
          });
          break;
        default:
          this.setState({ measurementInstructions: '' });
          break;
      }
    });

    measurement.startup();
    this.measurementTool = measurement;
  }

  closeMeasure() {
    mapActions.closeMeasure();
  }

  closeBasemap() {
    mapActions.closeBasemap();
  }

  toggleLegend() {
    mapActions.toggleLegend();
  }

  homeButton() {
    mapActions.goToSite();
  }

  render() {
    return (
      <div id={'mapContainer'} className={'map-container fill'}>
        <div id={'map'} className={'map fill'}>
          <div id='home-button' onClick={this.homeButton} />

          <div
            className={`login-container flex flex-column flex-justify-between ${
              this.state.showLoginOptions ? '' : 'hidden'
            }`}
          >
            <a
              className='waves-effect waves-light btn blue darken-3 margin-vertical'
              href={defaultStrings.accountUrl}
              target='_blank'
            >
              Manage My Account
            </a>
            <a
              className='waves-effect waves-light btn blue darken-3 margin-vertical'
              href={defaultStrings.signOutUrl + document.URL}
            >
              Logout
            </a>
          </div>

          <div className={`basemap-container ${this.state.showBasemapGallery ? '' : 'hidden'}`}>
            <span onClick={this.closeBasemap} className='close-measure'></span>
            <div id='basemapGallery'></div>
          </div>

          <div className={`measure-tool-container ${this.state.showMeasureTool ? '' : 'hidden'}`}>
            <div>
              <h5 className='measure-tool__title'>Measurement</h5>
              <span onClick={this.closeMeasure} className='close-measure'></span>
            </div>
            <div className='measure-tool-label-container'>
              <div className='measure-tool-label'>Area</div>
              <div className='measure-tool-label'>Distance</div>
              <div className='measure-tool-label'>Lat/Long</div>
            </div>
            <div id='measurementDiv' className='calcite'></div>
            <div className='measure-instructions'>{this.state.measurementInstructions}</div>
          </div>

          <div className={`share-tool-container ${this.state.showShareLink ? '' : 'hidden'}`}>
            <div className='share-links'>
              <h5 className='share-tool__title'>Share</h5>
            </div>
            <div className={`link-container ${this.state.showLink ? '' : 'hidden'}`}>
              <input type='text' value={this.state.link} />
              <button className='btn copy-link__button' data-clipboard-text={`${this.state.link}`}>
                Copy to clipboard
              </button>
            </div>
          </div>
        </div>

        <div className={`legend-container ${this.state.showLegend ? '' : 'no-legend'}`}>
          <div id={'legend-header'} className={'legend-header'}>
            Legend
          </div>
          <div className='legend-toggle' onClick={this.toggleLegend}></div>
          <div id={'legend'} className={'legend'}></div>
        </div>
      </div>
    );
  }
}
